'use client';
import { usePathname } from 'next/navigation';

export default function ReserveBannerWrapper() {
  const pathname = usePathname();
  // /branch/[branchSlug] 경로에서만 보이도록
  const showReserveBanner = pathname?.startsWith('/branch/');
  return showReserveBanner ? (
    <>
      {/** 웹 */}
      {/* <div className="desktop:block hidden">
        <BranchStickyBar />
      </div> */}
      {/**모바일 */}
      {/* <div className="desktop:hidden">
        <ReserveBanner />
      </div> */}
    </>
  ) : null;
}
